import { render, staticRenderFns } from "./editgiftcardstock.vue?vue&type=template&id=200cc740&scoped=true&"
import script from "./editgiftcardstock.vue?vue&type=script&lang=js&"
export * from "./editgiftcardstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cc740",
  null
  
)

export default component.exports